<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="d-md-block d-lg-block col-md-6 col-lg-6"  data-aos="fade-right">
                <div class="row">
                    <!-- <div class="col-sm-12" style="padding:0px;margin-top: 50px;" data-aos="fade-right">
                            <img class="about-me-img" style="padding: 50px; margin: 30px;" src="https://i.ibb.co/tmDSpqd/fun-3d-illustration-cartoon-kid-with-vr-helmet-183364-81193.png">
                        </div> -->
                    <div class="myphoto">
                        <img class="about-me-img"
                            src="../assets/profile.png" alt="Vrushaket's Profile Photo" />
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
                <div class="container" data-aos="fade-left">
                    <div class="row">
                        <div class="col-sm-12">
                            <h1 class="about-me">About Me</h1>
                        </div>
                        <div class="col-sm-12">
                            <p class="desc">
                                Full Stack Software Engineer with 3+ years of progressive experience from development to leadership roles, delivering scalable enterprise-grade solutions.
                            </p>
                        </div>
                        <div class="col-sm-12">
                            <table class="about-me-table table borderless">
                                <tr>
                                    <th>Name:</th>
                                    <td>Vrushaket Chaudhari</td>
                                </tr>
                                <tr>
                                    <th>Date of Birth:</th>
                                    <td>January 11, 2001</td>
                                </tr>
                                <tr>
                                    <th>Address:</th>
                                    <td>Pune, Maharashtra</td>
                                </tr>
                                <tr>
                                    <th>Pin Code:</th>
                                    <td>411046</td>
                                </tr>
                                <tr>
                                    <th>Email:</th>
                                    <td>vrushu00@gmail.com</td>
                                </tr>
                                <tr>
                                    <th>Phone:</th>
                                    <td>+91 95950 68833</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-sm-12">
                            <a href="https://drive.google.com/file/d/1jl4JH_r-rgTuA0G7LxMAaPa44rvgEejs/view?usp=sharing"
                                target="_blank">
                                <button class="cv-btn" data-aos="flip-down">
                                    Download Resume
                                </button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="container-fluid" data-aos="fade-up">
                <div class="row" style="display: flex; justify-content: center">
                    <a href="mailto:vrushu00@gmail.com" target="_blank"><svg class="social-img"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path
                                d="M207.8 20.73c-93.45 18.32-168.7 93.66-187 187.1c-27.64 140.9 68.65 266.2 199.1 285.1c19.01 2.888 36.17-12.26 36.17-31.49l.0001-.6631c0-15.74-11.44-28.88-26.84-31.24c-84.35-12.98-149.2-86.13-149.2-174.2c0-102.9 88.61-185.5 193.4-175.4c91.54 8.869 158.6 91.25 158.6 183.2l0 16.16c0 22.09-17.94 40.05-40 40.05s-40.01-17.96-40.01-40.05v-120.1c0-8.847-7.161-16.02-16.01-16.02l-31.98 .0036c-7.299 0-13.2 4.992-15.12 11.68c-24.85-12.15-54.24-16.38-86.06-5.106c-38.75 13.73-68.12 48.91-73.72 89.64c-9.483 69.01 43.81 128 110.9 128c26.44 0 50.43-9.544 69.59-24.88c24 31.3 65.23 48.69 109.4 37.49C465.2 369.3 496 324.1 495.1 277.2V256.3C495.1 107.1 361.2-9.332 207.8 20.73zM239.1 304.3c-26.47 0-48-21.56-48-48.05s21.53-48.05 48-48.05s48 21.56 48 48.05S266.5 304.3 239.1 304.3z" />
                        </svg></a>
                    <a href="https://www.linkedin.com/in/vrushaket-chaudhari/" target="_blank"><svg class="social-img"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path
                                d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                        </svg></a>
                    <a href="https://github.com/vrushaket" target="_blank"><svg class="social-img"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path
                                d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z" />
                        </svg></a>
                    <a href="https://twitter.com/" target="_blank"><svg class="social-img"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path
                                d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
                        </svg></a>
                    <a href="https://facebook.com/" target="_blank"><svg class="social-img"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path
                                d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
                        </svg></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AboutBlock",
    mounted() {
        AOS.init({
            duration: 1200,
            easing: "ease",
            once: false,
        });
    },
};
</script>

<style scoped>
/* prevent unwanted scrolls globally in this component */
:host, .col-sm-12 {
  overflow-x: hidden;
  overflow-y: hidden;
}

/* make the section container more flexible */
.container {
  padding: 60px 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
}

/* keep Bootstrap row clean */
.row {
  width: 100%;
  margin: 0;
}

/* photo column */
.myphoto {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/* image itself */
.about-me-img {
  border-radius: 50%;
  height: 280px;
  width: 280px;
  object-fit: cover;
  display: block;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

/* center text column vertically */
.text-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

/* typography */
.about-me {
  font-weight: bold;
  margin-bottom: 20px;
}

.desc {
  margin-bottom: 40px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* button */
.cv-btn {
  margin-top: 20px;
  border: none;
  background-color: #2f58cd;
  border-radius: 30px;
  padding: 10px 20px;
  color: white;
  transition: transform 0.3s;
  align-self: flex-start;
}

.cv-btn:hover {
  transform: scale(1.1);
  cursor: pointer;
}

/* social icons */
.social-img {
  height: 50px;
  width: 50px;
  margin: 20px;
  transition: transform 0.4s;
}

.social-img:hover {
  transform: scale(1.1);
}

/* remove Bootstrap table border */
.borderless td,
.borderless th {
  border: none;
}

/* responsive layout */
@media (max-width: 992px) {
  .about-me-img {
    height: 220px;
    width: 220px;
  }

  .cv-btn {
    align-self: center;
  }

  .social-img {
    margin: 10px;
  }
}

@media (max-width: 600px) {
  .about-me-img {
    height: 150px;
    width: 150px;
  }

  .container {
    padding: 40px 10px;
  }

  .text-column {
    align-items: center;
    text-align: center;
  }

  .cv-btn {
    align-self: center;
  }
}
.myphoto {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.col-md-6,
.col-lg-6 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.row {
  align-items: center;
}
.row {
  display: flex;
  align-items: center;    /* centers vertically */
  justify-content: center; /* centers horizontally */
  margin: 0;
  padding: 0;
}

.col-md-6,
.col-lg-6 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.myphoto {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.myphoto img {
  max-width: 100%;
}

</style>
